
import './App.css';
import AllRoutes from './Components/AllRoutes';

function App() {
  return (
    <div className="App" style={{justifyContent:"center",alignItems:"center"}}>
      <AllRoutes/>
    </div>
  );
}

export default App;
